module.exports = __webpack_public_path__ + "img/exam (2).76f88990.png";